import { z } from 'zod';

import { StepColorEnum } from '../../enums';
import { PaginationQuerySchema } from '../pagination';

export const SearchWordGroupsSchema = PaginationQuerySchema.extend({
  colors: z
    .preprocess(
      (val) => {
        if (typeof val === 'string' && val.length > 0) {
          return val.split(',');
        }
        return Array.isArray(val) ? val : undefined;
      },
      z.array(z.nativeEnum(StepColorEnum)).optional(),
    )
    .describe('Filter by an array of colors'),
  includeEmpty: z
    .preprocess((val) => {
      if (val === 'true') return true;
      if (val === 'false') return false;
      return undefined;
    }, z.boolean().optional())
    .describe('Include word groups that have no words. Defaults to false.'),
  name: z.string().optional(),
});

export type ISearchWordGroupsDto = z.infer<typeof SearchWordGroupsSchema>;
